import { InMemoryCache, defaultDataIdFromObject } from "@apollo/client";
import uniqBy from "lodash-es/uniqBy";

function mergeMessageList(existing, incoming, { readField, variables }) {
  if (!existing) return { ...incoming };

  // TODO Beware of blowup!
  // If no after argument is passed, we don't consider this pagination
  if (!variables.after) return { ...incoming };

  return {
    ...incoming,
    nodes: uniqBy([...existing.nodes, ...incoming.nodes], (item) =>
      readField("messageId", item)
    ).sort((a, b) => {
      const dateA = new Date(readField("date", a));
      const dateB = new Date(readField("date", b));

      return dateB - dateA;
    }),
  };
}

export default new InMemoryCache({
  dataIdFromObject: (object) => {
    // Only listmessages get special ID otherwise they would overlap
    if (object.__typename === "ListMessage") {
      return defaultDataIdFromObject(object) + object.mailboxId;
    }
    return defaultDataIdFromObject(object);

    const ids = Object.keys(object).filter((key) => key.match(/id/gi));

    if (ids.length > 1 || ids.length === 0)
      return defaultDataIdFromObject(object);
    return object[ids[0]];
  },

  typePolicies: {
    Query: {
      fields: {
        mailboxMessages: {
          keyArgs: ["input", ["mailboxId"]],
          merge: mergeMessageList,
        },
        searchMessages: {
          keyArgs: ["input", ["query", "mailboxId"]],
          merge: mergeMessageList,
        },
      },
    },
  },
});
